export const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;

export const templateCounts = (t) => [
  plural(t.attribute_count, 'attribute'),
  plural(t.positive_driver_count, 'Positive Driver'),
  plural(t.gap_count, 'Gap'),
].join(' · ');
